module.exports = __webpack_public_path__ + "img/progress-icon-01.9b84a097.gif";